var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "C2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      background: "white"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#73DDA2;}\r\n\t.st1{enable-background:new    ;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4099"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18,1.5c0.3,0,0.5,0.2,0.5,0.5v16c0,0.3-0.2,0.5-0.5,0.5H2c-0.3,0-0.5-0.2-0.5-0.5V2c0-0.3,0.2-0.5,0.5-0.5H18  M18,0H2C0.9,0,0,0.9,0,2v16c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V2C20,0.9,19.1,0,18,0L18,0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1,11.4c-0.1,0.9-0.4,1.6-1,2.2s-1.4,0.8-2.4,0.8c-1.1,0-2-0.4-2.6-1.1s-0.9-1.7-0.9-3V9.7c0-0.8,0.1-1.5,0.4-2.2 s0.7-1.1,1.2-1.4S6,5.6,6.7,5.6c1,0,1.8,0.3,2.4,0.8s0.9,1.3,1,2.2H8.3c0-0.6-0.2-1-0.5-1.2S7.2,7.1,6.7,7.1c-0.6,0-1,0.2-1.3,0.6 s-0.4,1.1-0.4,2v0.6c0,0.9,0.1,1.6,0.4,2s0.7,0.6,1.3,0.6c0.5,0,0.9-0.1,1.2-0.4s0.4-0.6,0.5-1.2H10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3,10.1l0.5-4.3h4.8v1.4h-3.4L13,9c0.4-0.2,0.8-0.3,1.3-0.3c0.8,0,1.4,0.3,1.9,0.8s0.7,1.2,0.7,2.1c0,0.6-0.1,1-0.3,1.5 s-0.6,0.8-1,1s-0.9,0.4-1.5,0.4c-0.5,0-1-0.1-1.4-0.3s-0.8-0.5-1-0.9s-0.4-0.8-0.4-1.3h1.7c0,0.4,0.2,0.6,0.4,0.8 c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,0.9-0.4s0.3-0.7,0.3-1.2c0-0.5-0.1-0.9-0.4-1.1s-0.6-0.4-1-0.4c-0.4,0-0.7,0.1-1,0.3 l-0.2,0.2L11.3,10.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC5);
export default __webpack_public_path__ + "static/media/C5.c9b7fca93cb48d4cbdcca7a5cbee9b92.svg";
export { ForwardRef as ReactComponent };